(function () {
  'use strict';

  const TRIGGER_SELECTOR = 'button[aria-label*="szukaj" i], button[aria-label*="search" i], a[href="/search"], [data-search-trigger]';
  const DEBOUNCE_MS = 250;
  const MIN_QUERY_LEN = 2;
  const MAX_RESULTS = 8;

  let modal, input, closeBtn, results, debounceTimer;
  let countDebounceTimer = null;
  let lastCountQuery = '';

  function polishPlural(n) {
    if (n === 1) return '1 WYNIK';
    if (n >= 2 && n <= 4) return n + ' WYNIKI';
    return n + ' WYNIKÓW';
  }

  async function fetchAndApplyCount(query) {
    if (!query) return;
    try {
      const url = '/search/suggest.json?q=' + encodeURIComponent(query)
        + '&resources[type]=product&resources[limit]=10';
      const r = await fetch(url);
      const j = await r.json();
      const total = (j && j.resources && j.resources.results && j.resources.results.products && j.resources.results.products.length) || 0;

      const text = total === 10 ? '10+ WYNIKÓW' : total > 0 ? polishPlural(total) : '';

      const apply = function () {
        document.querySelectorAll('dialog.ms-search-modal .ms-search-results-header__count')
          .forEach(function (el) { el.setAttribute('data-cro-count', text); });
      };
      apply();
      requestAnimationFrame(apply);
      setTimeout(apply, 100);
      setTimeout(apply, 300);
      setTimeout(apply, 700);
    } catch (e) {}
  }

  function init() {
    modal = document.getElementById('ms-search-modal');
    input = document.getElementById('ms-search-modal-input');
    closeBtn = document.getElementById('ms-search-modal-close');
    results = document.getElementById('ms-search-modal-results');

    if (!modal || !input || !closeBtn || !results) return;

    document.addEventListener('click', handleTriggerClick);
    closeBtn.addEventListener('click', closeModal);
    input.addEventListener('input', handleInput);

    input.addEventListener('input', function () {
      const q = input.value.trim();
      clearTimeout(countDebounceTimer);
      if (!q) {
        document.querySelectorAll('dialog.ms-search-modal .ms-search-results-header__count')
          .forEach(function (el) { el.removeAttribute('data-cro-count'); });
        lastCountQuery = '';
        return;
      }
      countDebounceTimer = setTimeout(function () {
        if (q === lastCountQuery) return;
        lastCountQuery = q;
        fetchAndApplyCount(q);
      }, 250);
    });

    modal.addEventListener('close', function () {
      input.value = '';
      results.innerHTML = '';
      modal.classList.remove('ms-search-modal--has-results');
      document.body.classList.remove('search-modal-open');
    });

    // Header click delegation — top-layer dialog blocks header clicks,
    // so we intercept clicks at header coords and route them manually.
    var HEADER_HEIGHT = 44;
    var X_ZONE_END = 60;       // hamburger/X zone: 0 → 60px
    var CART_ZONE_START = 340; // cart zone: 340px → viewport edge

    modal.addEventListener('click', function (e) {
      if (e.clientY > HEADER_HEIGHT) return;

      // X zone — close search
      if (e.clientX <= X_ZONE_END) {
        e.preventDefault();
        e.stopPropagation();
        modal.close();
        document.body.classList.remove('search-modal-open');
        return;
      }

      // Cart zone — close search + open cart drawer
      if (e.clientX >= CART_ZONE_START) {
        e.preventDefault();
        e.stopPropagation();
        modal.close();
        document.body.classList.remove('search-modal-open');
        setTimeout(function () {
          var cartBtn = document.querySelector('cart-drawer-component button.header-actions__action')
            || (document.querySelector('.header-actions__cart-icon') && document.querySelector('.header-actions__cart-icon').closest('button'))
            || document.querySelector('a[href="/cart"]');
          if (cartBtn) cartBtn.click();
        }, 50);
        return;
      }
    }, true);
  }

  function handleTriggerClick(e) {
    const trigger = e.target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;
    e.preventDefault();
    openModal();
  }

  function openModal() {
    if (!modal.open) {
      modal.showModal();
      document.body.classList.add('search-modal-open');
      setTimeout(function () { input.focus(); }, 50);
    }
  }

  function closeModal() {
    if (modal.open) modal.close();
    // body class removed in modal 'close' event handler
  }

  function handleInput() {
    clearTimeout(debounceTimer);
    const q = input.value.trim();

    if (q.length < MIN_QUERY_LEN) {
      results.innerHTML = '';
      modal.classList.remove('ms-search-modal--has-results');
      return;
    }

    debounceTimer = setTimeout(function () { fetchResults(q); }, DEBOUNCE_MS);
  }

  async function fetchResults(query) {
    try {
      const url = '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=' + MAX_RESULTS;
      const res = await fetch(url, { headers: { 'Accept': 'application/json' } });
      if (!res.ok) throw new Error('Search request failed: ' + res.status);
      const data = await res.json();
      const products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
      renderResults(products, query);
    } catch (e) {
      results.innerHTML = '<div class="ms-search-results__error">Błąd wyszukiwania. Spróbuj ponownie.</div>';
    }
  }

  function renderResults(products, query) {
    if (!products.length) {
      modal.classList.remove('ms-search-modal--has-results');
      results.innerHTML =
        '<div class="ms-search-results__empty">' +
          'Brak wyników dla "' + escapeHtml(query) + '". ' +
          '<a href="/search?q=' + encodeURIComponent(query) + '&type=product" class="ms-search-results__see-all">Zobacz pełną stronę wyników</a>' +
        '</div>';
      return;
    }

    modal.classList.add('ms-search-modal--has-results');

    const count = products.length;
    const countText = count >= MAX_RESULTS
      ? '+' + MAX_RESULTS + ' WYNIKÓW'
      : count + ' ' + (count === 1 ? 'WYNIK' : count < 5 ? 'WYNIKI' : 'WYNIKÓW');

    const header =
      '<div class="ms-search-results-header">' +
        '<span class="ms-search-results-header__count">' + escapeHtml(countText) + '</span>' +
        '<a class="ms-search-results-header__see-all" href="/search?q=' + encodeURIComponent(query) + '&type=product">ZOBACZ WSZYSTKIE</a>' +
      '</div>';

    const items = products.map(function (p) {
      const imgUrl = getImgUrl(p.featured_image);
      const price = formatPrice(p.price);
      const compareAt = p.compare_at_price_max && parseFloat(p.compare_at_price_max) > parseFloat(p.price)
        ? formatPrice(p.compare_at_price_max) : '';

      const priceHtml = compareAt
        ? '<span class="price-sale">' + escapeHtml(price) + '</span><s class="price-compare">' + escapeHtml(compareAt) + '</s>'
        : escapeHtml(price);

      return (
        '<a href="' + escapeAttr(p.url) + '" class="ms-search-results__item">' +
          '<div class="ms-search-results__item-img">' +
            (imgUrl ? '<img src="' + escapeAttr(imgUrl) + '" alt="' + escapeAttr(p.title) + '" loading="lazy">' : '') +
          '</div>' +
          '<div class="ms-search-results__item-title">' + escapeHtml(p.title) + '</div>' +
          '<div class="ms-search-results__item-price">' + priceHtml + '</div>' +
        '</a>'
      );
    }).join('');

    results.innerHTML =
      header +
      '<div class="ms-search-results__list">' + items + '</div>' +
      '<a href="/search?q=' + encodeURIComponent(query) + '&type=product" class="ms-search-results__see-all">' +
        'ZOBACZ WSZYSTKIE WYNIKI DLA "' + escapeHtml(query).toUpperCase() + '"' +
      '</a>';
  }

  // featured_image is an object {url, width, height} from /search/suggest.json
  function getImgUrl(featured_image) {
    if (!featured_image) return '';
    if (typeof featured_image === 'string') return featured_image;
    const url = featured_image.url || '';
    return url.startsWith('//') ? 'https:' + url : url;
  }

  // price comes as "289.00" string from suggest API — convert to "289,00 zł"
  function formatPrice(str) {
    if (!str) return '';
    const num = parseFloat(str);
    if (isNaN(num)) return String(str);
    return num.toFixed(2).replace('.', ',') + '\u00a0zł';
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function escapeAttr(s) {
    return escapeHtml(s);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
